export default __webpack_public_path__ + "static/media/doctor4.bbe88b03.jpg";